import {order as apis} from '@/api/finance'
// 运单审核
const listConfig = [
    {title: '发车时间', key: 'hairCarTime'},
    {title: '线路', key: 'roadName', width: 200},
    {title: '车号', key: 'carNo'},
    {
        title: '车型', key: 'carTypeId', showData: {
            '1': '4.2米',
            '2': '6.8米',
            '3': '7.2米',
            '4': '9.6米',
            '5': '13米',
            '6': '14.2米',
            '7': '16.5米',
            '8': '17.5米',
        }
    },
    {
        title: '运单状态', key: 'statusOver',
        color: {
            '2': '#FF5B45',
        },
        showData: {
            '1': '准时',
            '2': '超时',
            default: ''
        }
    },
    {title: '到车运费', key: 'tcFreight'},
    {title: '到车油卡', key: 'tcOilCard'},
    {
        title: '结算方式', key: 'jieType', showData: {
            '1': '全部结算',
            '2': '部分结算',
            default: ''
        }
    },
    {title: '押金', key: 'yaMoney'},
    {title: '申请金额', key: 'applyMoney'},
    {title: '发起人', key: 'proposerName'},
    {title: '发起时间', key: 'initiateTime'}
]

function createSearch(list) {
    return [
        {title: '发车时间', value: [], key: 'hairCarTime', type: 'date2'},
        {title: '线路', value: '', key: 'roadId', type: 'select', list},
        {title: '车牌号', value: '', key: 'carNo', type: 'input'},
        {title: '提审时间', value: '', key: 'initiateTime', type: 'date2'},
        {title: '姓名', value: '', key: 'driverName', type: 'input'},
        {title: '电话', value: '', key: 'driverTel', type: 'input'},
        {title: '承运商', value: '', key: 'supplierName', type: 'input'},
    ]
}

const btnConfig = [
    {bg: '#19458C', title: '提 交', key: 'submit', role: 'Submit'},
    {bg: '#EA5B24', title: '驳 回', key: 'reject', role: 'Reject'},
    {title: '备注', key: 'remark', role: 'BZ'},
]

function fromConfig() {
    return [
        {title: '车牌号', value: '', key: 'carNo', type: 'input'},
        {title: '车型', value: '', key: 'carType', type: 'input'},
        {title: '挂车号', value: '', key: 'carGno', type: 'input'},
    ]
}

function createRemark() {
    return [{title: '备注', value: '', key: 'remark', type: 'textarea', span: 24}]
}

const notRequired = true;

function createSubmit() {
    return [
        {column: '提 交'},
        {title: '保险', value: '', key: 'insurance', type: 'input', span: 6, notRequired},
        {title: '罚款', value: '', key: 'fine', type: 'input', span: 6, notRequired},
        {title: '补助', value: '', key: 'subsidy', type: 'input', span: 6, notRequired},
        {title: '备注', value: '', key: 'remark', type: 'textarea', span: 24, notRequired},
    ]
}

function createReject() {
    return [
        {column: '驳 回'},
        {title: '审批备注', value: '', key: 'remark', type: 'textarea', span: 24, notRequired},
    ]
}

const detailConfig = [
    {column: '派车信息'},
    {
        title: '线路',
        key: 'roa',
        value: '',
        transform(data) {
            return `${data.startLocation}-${data.targetLocation}`
        }
    },
    {
        title: '运输方式',
        value: '',
        key: 'runType',
        transform(data) {
            const _data = {
                '1': '合流',
                '2': '整车',
                '3': '经停'
            }
            return _data[data[this.key]]
        }
    },
    {title: '总里程', value: '', key: 'mileage'},
    {
        title: '车型', value: '', key: 'carTypeId',
        transform(data) {
            const _data = {
                '1': '4.2米',
                '2': '6.8米',
                '3': '7.2米',
                '4': '9.6米',
                '5': '13米',
                '6': '14.2米',
                '7': '16.5米',
                '8': '17.5米',
            }
            return _data[data[this.key]]
        }
    },
    {title: '体积', value: '', key: 'volume'},
    {title: '重量', value: '', key: 'weight'},
    {
        title: '始发地', value: '', key: 'startLocation',
        transform(data) {
            return data.provenance ? data.provenance : data.startLocation
        }
    },
    {title: '经停点', value: '', key: 'passLocation'},
    {
        title: '目的地', value: '', key: 'targetLocation',
        transform(data) {
            return data.destination ? data.destination : data.targetLocation
        }
    },
    {
        title: '客户时效',
        value: '',
        key: 'clientTime',
        transform({clientTime}) {
            const m = ~~clientTime % 60;
            const s = (~~clientTime - m) / 60;
            let _mstr = `${m}分`
            if (s > 0) _mstr = `${s}时` + _mstr
            return _mstr
        }
    },
    {title: '运单号', value: '', key: 'planOrder'},
    {title: 'GPS设备号', value: '', key: 'gpsNo'},
    {
        title: '平台结算', value: '', key: 'platformSettlementType',
        transform(data) {
            const _data = {
                1: '月结',
                2: '个体',
            }
            return _data[data[this.key]]
        }
    },
    {title: '平台收款人', value: '', key: 'payee'},
    {title: '创建日期', value: '', key: 'createTime'},
    {column: '车辆信息 '},
    {title: '车牌号', value: '', key: 'carNo'},
    {title: '车型', value: '', key: 'carType'},
    {title: '挂车号', value: '', key: 'carGno'},
    {title: '司机', value: '', key: 'driverName'},
    {title: '电话', value: '', key: 'driverTel'},
    {title: '承运商', value: '', key: 'supplierName'},
    {title: '收款人', value: '', key: 'moneyp'},
    {title: '帐号', value: '', key: 'moneya'},
    {title: '开户行', value: '', key: 'bank'},
    {title: '调派员', value: '', key: 'dispatcherName'},
    {title: '发车时间', value: '', key: 'hairCarTime'},
    {title: '到达时间', value: '', key: 'arriveCarTime'},
    {
        title: '运输时长', value: '', key: '',
        transform(data) {
            const date3 = new Date(data.arriveCarTime) - new Date(data.hairCarTime);
            //计算出相差天数
            const days = Math.floor(date3 / (24 * 3600 * 1000))
            //计算出小时数
            const leave1 = date3 % (24 * 3600 * 1000)  //计算天数后剩余的毫秒数
            const hours = Math.floor(leave1 / (3600 * 1000))
            //计算相差分钟数
            const leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
            const minutes = Math.floor(leave2 / (60 * 1000))
            let _str = `${minutes}分`
            if ((hours + days * 24) > 0) _str = `${hours + days * 24}时` + _str
            return _str
        }
    },
    {
        title: '到达状态', value: '', key: 'statusOver',
        transform(data) {
            const _data = {
                '1': '准时',
                '2': '超时',
            }
            return _data[data[this.key]]
        }
    },
    {
        title: '回单回收', value: '', key: 'hdReply',
        isShowImg: true,
        imgKsy: 'hdPicture',
        transform(data) {
            const _data = {
                '1': '纸质回单已回收',
                '2': '无纸电子回单'
            }
            return _data[data[this.key]]
        }
    },
    {
        title: 'GPS设备回收', value: '', key: 'gps',
        isShowImg: true,
        imgKsy: 'gpsPicture',
        transform(data) {
            const _data = {
                '1': '临时外调已回收',
                '2': '长期合作固定设备'
            }
            return _data[data[this.key]]
        }
    },
    {column: '财务信息'},
    {title: '到车运费', value: '', key: 'tcFreight'},
    {
        title: '结算状态', value: '', key: 'statusJie',
        transform(data) {
            const _data = {
                '1': '已结算',
                '2': '未结算',
                '3': '部分结算',
                '4': '申请中'
            }
            return _data[data[this.key]]
        }
    },
    {title: '结算时间', value: '', key: 'jieTime'},
    {title: '到车油卡', value: '', key: 'tcOilCard'},
    {title: '油卡充值方式', value: '', key: 'oilPayType'},
    {title: '充值时间', value: '', key: 'oilPayTime'},
    {title: '押金', value: '', key: 'yaMoney'},
    {title: '保险', value: '', key: 'insurance'},
    {title: '罚款', value: '', key: 'fine'},
    {title: '补助', value: '', key: 'subsidy'},
    {title: '结算金额', value: '', key: 'applyMoney'},
    {
        title: '审核运单',
        key: 'auditWaybill', span: 16, value: '',
        transform(data) {
            if (!data.auditWaybill) return ''
            return [
                {label: '运单相符', value: '1'},
                {label: '运价正确', value: '2'},
                {label: '信息正确', value: '3'}
            ].filter(item => data.auditWaybill.split(",")
                .indexOf(item.value) > -1
            ).map(x => x.label).join("，");
        }
    },
    {column: '结算记录'},
    {
        key: 'operation_jieRecord', span: 24, value: '',
        transform(data) {
            return data.jieRecord
        }
    },
    {column: '异常上报'},
    {
        key: 'operation_orderRunTrackList', span: 24, value: '',
        transform(data) {
            return data.orderRunTrackList
        }
    },
    {column: '备注'},
    {
        key: 'operation_remark', span: 24, value: '',
        transform(data) {
            return data.remarks
        }
    },
    {column: '操作记录'},
    {
        key: 'operation_record', span: 24, value: '',
        transform(data) {
            return data.logs
        }
    },
]

export default function config() {
    return {
        detailConfig,
        listConfig,
        btnConfig,
        fromConfig,
        createSearch,
        createSubmit,
        createRemark,
        createReject,
        apis
    }
}
